import { useParams, Link } from 'react-router-dom';
import { useClinic } from '../hooks/useApi';
import AppointmentForm from '../components/AppointmentForm';
import { ChevronRight } from 'lucide-react';

export default function BookAppointmentPage() {
  const { clinicSlug } = useParams<{ clinicSlug: string }>();
  const { data: clinic, isLoading } = useClinic(clinicSlug || '');

  if (isLoading) {
    return (
      <div role="status" aria-busy="true" aria-label="Loading booking form" className="max-w-2xl mx-auto px-4 py-8">
        <div className="skeleton h-4 w-48 mb-6" />
        <div className="skeleton h-8 w-64 mb-2" />
        <div className="skeleton h-4 w-40 mb-6" />
        <div className="card space-y-4">
          <div className="skeleton h-10 w-full" />
          <div className="skeleton h-10 w-full" />
          <div className="skeleton h-24 w-full" />
          <div className="skeleton h-10 w-32 rounded-full" />
        </div>
      </div>
    );
  }

  if (!clinic) {
    return (
      <div className="text-center py-16">
        <h2 className="text-2xl font-bold text-navy mb-4">Clinic Not Found</h2>
        <Link to="/clinics" className="btn btn-primary">Find Clinics</Link>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <Link to="/clinics">Find Clinics</Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <Link to={`/clinics/${clinic.slug}`}>{clinic.name}</Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <span className="text-navy font-medium">Book</span>
      </div>

      <h1 className="text-2xl font-extrabold text-navy mb-1">Book Appointment</h1>
      <p className="text-gray-400 mb-6">{clinic.name}</p>

      <div className="card">
        <AppointmentForm clinicId={clinic.id} services={clinic.services || []} />
      </div>
    </div>
  );
}
